
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/custom-plugin.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-custom-plugin-demo-custom","docs-x-markdown-custom-plugin-demo-marked"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/custom-plugin.en-US.md?type=demo')
};